import { useEffect, useState } from 'react';
import { supabase } from '../config/supabase';

export const usePrivacyPolicy = () => {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSections = async () => {
      try {
        setLoading(true);
        setError(null);

        console.log('🔍 Fetching privacy policy sections...');
        const { data, error: fetchError } = await supabase
          .from('privacy_policy')
          .select('*')
          .eq('is_active', true)
          .order('section_order', { ascending: true });

        console.log('📊 Privacy policy response:', { data, error: fetchError });

        if (fetchError) {
          console.error('❌ Privacy policy fetch error:', fetchError);
          throw fetchError;
        }

        console.log(`✅ Loaded ${data?.length || 0} privacy policy sections`);
        setSections(data ?? []);
      } catch (err) {
        console.error('❌ Error fetching privacy policy:', err);
        setError(err.message || 'Failed to load privacy policy');
        setSections([]);
      } finally {
        setLoading(false);
      }
    };

    fetchSections();
  }, []);

  return { sections, loading, error };
};

